<template>
    <div class="col-xs-12 col-sm-8">
        <h5 class="font400 text-uppercase mb-15 font16">Servicios Disponibles</h5>
        <ul class="list-col-2 list-with-icon">

            <li>
                <font-awesome-icon style="margin-right: 0.5em;" icon="check" class="text-primary"/>
                Catering
            </li>
            <li>
                <font-awesome-icon style="margin-right: 0.5em;" icon="check" class="text-primary"/>
                Videoconferencia
            </li>
            <li>
                <font-awesome-icon style="margin-right: 0.5em;" icon="times" class="text-danger"/>
                Zoom Rooms
            </li>
            <li>
                <font-awesome-icon style="margin-right: 0.5em;" icon="times" class="text-danger"/>
                Videovigilancia
            </li>
            <li>
                <font-awesome-icon style="margin-right: 0.5em;" icon="check" class="text-primary"/>
                Cafetería
            </li>
            <li>
                <font-awesome-icon style="margin-right: 0.5em;" icon="check" class="text-primary"/>
                Limpieza
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "meetingServices"
    }
</script>

<style scoped>
    .text-primary {
        color: #8ac6c4 !important;
    }

    .text-danger {
        color: #868686 !important
    }
</style>